// app/utils/tags.ts
import type { ProductType } from '~/utils/api/common';
import { slugify } from '~/utils/slugify';

export interface ProductTag {
  slug: string;
  label: string;
}

const LABEL_BADGE_TYPE = 'label';

/** Slugs of the "label" badges attached to a single product. */
export const getProductTagSlugs = (product: ProductType): string[] => {
  if (!product.badges) return [];
  const slugs: string[] = [];
  for (const badge of product.badges) {
    if (badge.type === LABEL_BADGE_TYPE && badge.text) {
      slugs.push(slugify(badge.text));
    }
  }
  return slugs;
};

/** Unique tag catalogue across all products, in first-seen order. */
export const collectProductTags = (products: ProductType[]): ProductTag[] => {
  const seen = new Map<string, ProductTag>();
  for (const product of products) {
    if (!product.badges) continue;
    for (const badge of product.badges) {
      if (badge.type !== LABEL_BADGE_TYPE) continue;
      const text = badge.text;
      if (!text) continue;
      const slug = slugify(text);
      if (!seen.has(slug)) seen.set(slug, { slug, label: text });
    }
  }
  return [...seen.values()];
};

/** slug → label lookup (route validation + chip labels). */
export const buildTagSlugMap = (products: ProductType[]): Map<string, string> => {
  const map = new Map<string, string>();
  for (const tag of collectProductTags(products)) map.set(tag.slug, tag.label);
  return map;
};
